import React from 'react'
import Box from '@mui/material/Box'
import LoadingProgress from './LoadingProgress'

/**
 * See UserAccountsSummaryTable.tsx for an example use case.
 * It resides within the TableContainer component, and when active, will overlay over that entire component.
 * Note, the parent container will most likely need a position: relative style applied to show the spinner centered in the correct spot.
 */

interface CircularProgressOverlayProps {
  /**
   * Determines whether to show the loading spinner or not
   */
  isLoading: boolean
}

/**
 * A utility component that overlays a loading spinner over the content it resides within, maintaining the size of its parent container.
 */
const CircularProgressOverlay: React.FC<CircularProgressOverlayProps> = ({
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: '100vh',
          width: '100vw',
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.1)',
        }}
      >
        <LoadingProgress />
      </Box>
    )
  }

  return null
}

export default CircularProgressOverlay
